module.exports = __webpack_public_path__ + "static/media/sign-in-background.a86e46dd.jpg";